<template>
    <Header></Header>
    <Slider></Slider>
    <Rates></Rates>
    <Features></Features>
    <Currencies></Currencies>
    <News></News>
    <Partners></Partners>
    <FAQ></FAQ>
    <Footer></Footer>
</template>

<script>
import Header from '@/components/Header.vue'
import Slider from '@/components/Main/Slider.vue'
import Rates from '@/components/Main/Rates.vue'
import Currencies from '@/components/Main/Currencies.vue'
import Features from '@/components/Main/Features.vue'
import News from '@/components/Main/News.vue'
import Partners from '@/components/Main/Partners.vue'
import FAQ from '@/components/Main/FAQ.vue'
import Footer from '@/components/Footer.vue'

export default {
    components: {
        Header,
        Slider,
        Rates,
        Currencies,
        Features,
        News,
        Partners,
        FAQ,
        Footer
    }
}
</script>